import { privateAxios } from 'services/api/privateAxios';

export const getInventory = () =>
  privateAxios({
    method: 'get',
    url: '/driver/inventory',
  });
